// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-l_gW","advertDetailContactItem__link":"c-l_gX","advertDetailContactItem__stub":"c-l_gY"};